import React from 'react';
import { Link } from "react-router-dom";

export default () => {
  return(
    <div>
      <h3 className="text-center">
        <Link to={`/`}>1024</Link>
      </h3>
      {/*<ul>
        <li>
          <Link to={`/utils`}>Utils</Link>
        </li>
      </ul>
      <p className="App-caption text-center">Photo by Robert Lamb on Unsplash</p>*/}
    </div>
  )
}
